import { format } from 'owa-localize';
import { TODO_API_UPDATE_SETTING } from './constants';
import getTodoRequestHeaders from './getTodoRequestHeaders';
import { TodoSetting } from './TodoSetting';
import { isSuccessStatusCode } from 'owa-http-status-codes';
import { makePatchRequest } from 'owa-ows-gateway';

export function updateSettingService(settingUpdate: TodoSetting): Promise<boolean> {
    const url = format(TODO_API_UPDATE_SETTING, settingUpdate.Key);
    return makePatchRequest(
        url,
        settingUpdate,
        null /* correlationId */,
        true /* returnFullResponse */,
        getTodoRequestHeaders()
    )
        .then((response: Response) => {
            return isSuccessStatusCode(response.status);
        })
        .catch(err => {
            return false;
        });
}
